import React, { useState, useCallback, useRef, Fragment } from "react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";
import { Listbox, Transition } from "@headlessui/react";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const CountrySelect = ({ selectedLocation = null, label, onChange, countries }) => {
  const [touchedOption, setTouchedOption] = useState(null);

  const handleTouchStart = useCallback((option) => {
    setTouchedOption(option);
  }, []);

  const handleTouchEnd = useCallback(() => {
    // Clear the touched state after a short delay to allow the selection to complete
    setTimeout(() => setTouchedOption(null), 200);
  }, []);

  if (selectedLocation?.name === "Europe") {
    selectedLocation.name = "Anywhere in Europe 🌍"
  }

  countries = countries.map((country) => ({
    ...country,
    name: country.name === "Europe" ? "Anywhere in Europe 🌍" : country.name
  }));

  return (
    <Listbox as="div" value={selectedLocation} onChange={onChange}>
      <Listbox.Label className="block text-sm font-medium text-black">
        {label}
      </Listbox.Label>
      <div className="relative mt-1">
        <Listbox.Button className="block relative w-full cursor-default rounded-full border border-gray-300 bg-white py-2 pl-4 pr-10 text-left shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm">
          <span className="block truncate">{selectedLocation?.name || "Select a country"}</span>
          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
          </span>
        </Listbox.Button>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-200"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="transition ease-in duration-150"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
            {countries.map((option) => (
              <Listbox.Option
                key={option.name}
                value={option}
                onTouchStart={() => handleTouchStart(option)}
                onTouchEnd={handleTouchEnd}
                className={({ active }) =>
                  classNames(
                    "relative cursor-default select-none py-2 pl-10 pr-4 active:bg-indigo-600 active:text-white",
                    (active || touchedOption?.name === option.name) ? "bg-indigo-600 !text-white" : "text-gray-900"
                  )
                }
              >
                {({ selected, active }) => (
                  <>
                    <span className={classNames("block truncate", selected ? "font-medium" : "font-normal")}>
                      {option.name}
                    </span>
                    {selected ? (
                      <span
                        className={classNames(
                          "absolute inset-y-0 left-0 flex items-center pl-3",
                          active ? "text-white" : "text-indigo-600"
                        )}
                      >
                        <CheckIcon className="h-5 w-5" aria-hidden="true" />
                      </span>
                    ) : null}
                  </>
                )}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Transition>
      </div>
    </Listbox>
  );
};

export default CountrySelect;